import { DatasourcesStatusOutputV1 } from '@/sdk';
import { PersistenceLevel, Store } from '@/core/flux.service';

export class DatasourcesStore extends Store {
  persistenceLevel: PersistenceLevel = 'NONE';
  static readonly storeName = 'sqDatasourcesStore';

  initialize() {
    this.state = this.immutable({
      datasources: undefined,
    });
  }

  get datasources(): DatasourcesStatusOutputV1 {
    return this.state.get('datasources');
  }

  protected readonly handlers = {
    DATASOURCES_SET_DATASOURCES: ({ datasources }: { datasources: DatasourcesStatusOutputV1 }) => {
      this.state.set('datasources', datasources);
    },
  };
}
